import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { PHONE_TEL, reportConversion, waLink } from "../../data/site";

export default function FloatingCtas() {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, x: 40 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.7, delay: 1.4, ease: [0.22, 1, 0.36, 1] }}
        className="fixed bottom-6 right-6 z-50 hidden flex-col items-end gap-3 md:flex"
        data-testid="floating-ctas"
      >
        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          onClick={reportConversion}
          aria-label="Get quote on WhatsApp"
          data-testid="floating-whatsapp-button"
          className="group flex items-center gap-2.5"
        >
          <span className="rounded-md bg-ink px-2.5 py-1.5 text-xs font-semibold text-white shadow-md">
            WhatsApp
          </span>
          <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-wa text-white shadow-lg shadow-black/20 transition-transform duration-200 group-hover:scale-110">
            <span className="absolute inset-0 animate-ping rounded-full bg-wa/40" aria-hidden="true" />
            <MessageCircle className="relative h-6 w-6" />
          </span>
        </a>
        <a
          href={PHONE_TEL}
          onClick={reportConversion}
          aria-label="Call now"
          data-testid="floating-call-button"
          className="group flex items-center gap-2.5"
        >
          <span className="rounded-md bg-ink px-2.5 py-1.5 text-xs font-semibold text-white shadow-md">
            Call Now
          </span>
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-tangy text-white shadow-lg shadow-black/20 transition-transform duration-200 group-hover:scale-110">
            <Phone className="h-6 w-6" />
          </span>
        </a>
      </motion.div>

      <div
        className="fixed bottom-0 left-0 z-50 grid w-full grid-cols-2 border-t border-ink/20 md:hidden"
        data-testid="mobile-bottom-cta"
      >
        <a
          href={PHONE_TEL}
          onClick={reportConversion}
          data-testid="mobile-call-button"
          className="flex items-center justify-center gap-2 bg-brand-dark py-4 text-sm font-semibold text-white active:bg-brand-deep"
        >
          <Phone className="h-4 w-4" />
          Call Now
        </a>
        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          onClick={reportConversion}
          data-testid="mobile-whatsapp-button"
          className="flex items-center justify-center gap-2 bg-wa py-4 text-sm font-semibold text-white active:bg-mint-dark"
        >
          <MessageCircle className="h-4 w-4" />
          WhatsApp Quote
        </a>
      </div>
    </>
  );
}
